import { Card, Stack, Box, styled } from '@mui/material';

import { colors } from '@/theme/variables';
export const KaseMasterCard = styled(Card)(({ theme }) => ({
  backgroundColor: 'transparent',
  height: '100%',
  borderRadius: '8px',
  overflow: 'hidden',
  '.MuiAutocomplete-root': {
    backgroundColor: theme.palette.background.paper,
  },
  '&.MuiPaper-root .MuiTableContainer-root:first-of-type': {
    padding: 16,
    marginTop: 16,
    backgroundColor: theme.palette.background.paper,
  },
  boxShadow: 'none',
  '& .master-names-screen, & .master-vehicle-screen': {
    border: 0,
    padding: 0,
  },
}));

export const kaseTabShellSx = {
  p: 1.5,
  mt: 1.5,
  borderRadius: 2,
} as const;

export const PrimaryNarrativeStack = styled(Stack)(() => ({
  width: '100%',
  padding: '0 15px',

  '& .narrative-title': {
    marginBottom: '10px',
    lineHeight: '24px',
    fontWeight: 500,
  },

  '& .narrative-description': {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '20px',
  },
}));

export const RestrictedTableCell = styled(Box)(() => ({
  width: '80px',
  height: '20px',
  backgroundColor: colors.itemGrey,
  marginTop: '8px',
}));
